import { BasketState } from '@websrc/Typings/DanteBasket'

import { BasketApiMethod, QueueManagerObject, QueueRequest } from './BasketTypes'
import { callBasketApi } from './callBasketApi'

export function createBasketApi(
  enable: boolean,
  onUpdate: (basketState: BasketState) => void
): BasketApiMethod {
  if (!enable) {
    return () => Promise.resolve([null, null])
  }

  const initialRequest: QueueRequest = {
    method: 'POST',
    endpoint: '',
    onSuccess: () => {},
  }

  const queueManager: QueueManagerObject = {
    reqs: [initialRequest],
    isRunning: false,
  }

  const run = async () => {
    // Don't run if already running or no requests need to get fired
    if (queueManager.isRunning) return
    const request = queueManager.reqs.shift()

    if (!request) {
      return
    }

    queueManager.isRunning = true

    const [err, res] = await callBasketApi(request)

    // State is a new basket state
    if (res && typeof res === 'object' && (res as BasketState).id && (res as BasketState).meta) {
      onUpdate(res as BasketState)
    }

    request.onSuccess([err, res])

    // eslint-disable-next-line require-atomic-updates
    queueManager.isRunning = false

    void run()
  }

  void run()

  return (endpoint, method = 'GET', body, formData) => {
    return new Promise((resolve) => {
      queueManager.reqs.push({
        method,
        body,
        formData,
        endpoint,
        onSuccess: resolve,
      })

      void run()
    })
  }
}
